module.exports = __webpack_public_path__ + "img/evanghelie-1682-pagina-de-titlu-big.1f166b98.jpg";